import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import AppRouter from './router';
import { ThemeProvider } from './context/ThemeContext';
import { logger } from './services/logger';
import { KeyboardShortcutsProvider } from './context/ShortcutsContext';

const App: React.FC = () => {
  logger.info('Application initialized');
  
  return (
    <Provider store={store}>
      <ThemeProvider>
        <KeyboardShortcutsProvider>
          <AppRouter />
        </KeyboardShortcutsProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
